import type { AirlineRegionScore, AirlineScore, AirportRegionScore, AirportScore } from "services/scores";
import type { GetStoryblokAssetReturnType, ISbAsset } from "./types";

export const STORYBLOK_ASSET_MANAGER_URL = "https://a.storyblok.com";

export const getStoryblokAsset = (asset: ISbAsset): GetStoryblokAssetReturnType => {
  if (!asset) return { assetSource: "", assetAlt: "" };
  const { filename, alt } = asset;

  return {
    assetSource: filename,
    assetAlt: alt,
  };
};

export const optimiseStoryblokImage = (url: string) => url && `${url}/m/`;

export const isAirlineScore = (item: AirportScore | AirlineScore): item is AirlineScore => "airline" in item;
export const isBestAirlineByRegion = (item: AirlineRegionScore | AirportRegionScore): item is AirlineRegionScore =>
  "airline" in item;
